import { API_URL } from "../../constans/roles";
import { fetchJson } from "../fetch";

export const uploadSlideshowFiles = async (formData) =>
  fetchJson(`${API_URL}/api/slideshow/upload`, {
    method: "POST",
    reqToken: false,
    body: formData,
  });

export const uploadFooterImage = async (formData) =>
  fetchJson(`${API_URL}/api/footerGenerator/upload`, {
    method: "POST",
    reqToken: false,
    body: formData,
  });

export const uploadLinksArchive = async (formData) =>
  fetchJson(`${API_URL}/api/linki/upload`, {
    method: "POST",
    reqToken: false,
    body: formData,
  });

export const loadFeedColumnsPreview = async (formData) =>
  fetchJson(`${API_URL}/api/feed/columns`, {
    method: "POST",
    reqToken: false,
    body: formData,
  });

export const generateFeedFile = async (formData) =>
  fetchJson(`${API_URL}/api/feed/generate`, {
    method: "POST",
    reqToken: false,
    body: formData,
  });
